var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-sheet-location-large',{attrs:{"html-content":_vm.locationAdditionalDetails.longRichText,"logo-image-url":_vm.locationAdditionalDetails.logoImgUrl,"share-url":_vm.currentUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }